module.exports = __webpack_public_path__ + "static/img/vip-info2.fa688b15.png";